import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import useCO2EmissionsLogo from '@/shared/product/details/emissions/useCO2EmissionsLogo';


export default /*#__PURE__*/_defineComponent({
  __name: 'CO2EmissionsLogo',
  setup(__props) {

const { logo } = useCO2EmissionsLogo();

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_unref(logo))
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _unref(logo).model.url,
        "aria-hidden": "true"
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createBlock(_component_c_icon, {
        key: 1,
        name: "icon-co2e",
        "aria-hidden": "true"
      }))
}
}

})